import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { PinSpaceContribution } from './pin-space-contribution';
export function pinSpaceModule(bind) {
    bind(CommandContribution).to(PinSpaceContribution);
}
